module.exports = __webpack_public_path__ + "assets/reject-cancel.f7ec8505.svg";